import { Dispatch } from 'redux';
import { createAction } from 'typesafe-actions';
import { EntitiesState, GraveTypes } from 'types';
import { GraveType } from 'mymoria-types';
import { api } from 'utils';
import { normalize, schema } from 'normalizr';
import { groupBy } from 'lodash';

const graveType = new schema.Entity('graveTypes');

interface FetchGraveTypesAction {
  entities: Pick<EntitiesState, 'graveTypes'>;
  result: GraveTypes;
}
const graveTypesSchema = {
  cremation: [graveType],
  burial: [graveType],
  sea: [graveType],
  tree: [graveType],
};

const fetchGraveTypesAction = createAction('FETCH_GRAVE_TYPES')<FetchGraveTypesAction>();

export default {
  fetchGraveTypes: fetchGraveTypesAction,
};

export const fetchGraveTypes = () => (dispatch: Dispatch) =>
  api.get<GraveType[]>(`/gravetypes/`).then(({ data }) => {
    const graveTypes = groupBy(data, 'funeralType');

    return dispatch(fetchGraveTypesAction(normalize(graveTypes, graveTypesSchema)));
  });
